// @flow
import React from 'react';
import Helmet from 'react-helmet';
import { Redirect, Route, Switch } from 'react-router';
import NoMatch from '../NoMatch';
import TicketList from '../TicketList';
import TicketDetail from '../TicketDetail';
import AssignApplicantDialog from '../AssignApplicantDialog';
import AssignDialog from '../AssignDialog';
import CancelDialog from '../CancelDialog';
import ExtendDialog from '../ExtendDialog';
import OptinDialog from '../OptInDialog';
import ReopenDialog from '../ReopenDialog';
import RescheduleDialog from '../RescheduleDialog';
import ScheduleDialog from '../ScheduleDialog';
import UnassignDialog from '../UnassignDialog';

export default () => (
    <div>
        <Helmet title="Tickets" />
        <Switch>
            <Route path="/tickets/:orgId/:view(list|map)" component={TicketList} />
            <Route path="/tickets/:orgId/info/:ticketId" component={TicketDetail} />
            <Redirect from="/tickets/:orgId/detail/:ticketId" to="/tickets/:orgId/info/:ticketId" />
            <Route component={NoMatch} />
        </Switch>
        <AssignApplicantDialog />
        <AssignDialog />
        <CancelDialog />
        <ExtendDialog />
        <OptinDialog />
        <ReopenDialog />
        <RescheduleDialog />
        <ScheduleDialog />
        <UnassignDialog />
    </div>
);
